import { Flex, Text } from "@chakra-ui/react";
import { FC, ReactElement } from "react";

interface PasswordDescriptionProps {
  description: string;
  color: string;
  icon: ReactElement;
}

const PasswordDescription: FC<PasswordDescriptionProps> = ({
  description,
  color,
  icon,
}) => {
  return (
    <Flex alignItems="center" gap="2">
      <Flex as="span" color={color} justifyItems="center">
        {icon}
      </Flex>
      <Text color={color} fontSize="sm">
        {description}
      </Text>
    </Flex>
  );
};

export default PasswordDescription;
